module.exports = __webpack_public_path__ + "img/8.205c361e.jpg";